// import Axios from 'axios'
import Axios from "@/helpers/axios";
import router from '@/router';

export default {
    FETCH_BANKS(context,co2) {
        Axios.get(`/bank?co2=150`)
            .then(res => {
                context.commit('SET_DATA', {
                    field: 'banks',
                    data: res.data
                })
                // context.state.banks = res.data
                // console.log(res.data[0].description)
            })
            .catch()
    },
    FETCH_CAR: (context, car_id) => {
        let referrer = null;
        if (document.referrer) {
            referrer = document.referrer;
        }

        const flagCarInStock = context.getters.flagCarInStock;
        const view_key = localStorage.getItem('view_key');
        const url = `/new-cars/get-car?id=` + car_id + "&app=" + context.state.isApp + "&referrer=" + referrer + "&status=" + (flagCarInStock ? 2 : 1)+"&view_key="+view_key;
        return  Axios.get(url).then(res => {
            context.commit('SET_CAR', res.data);
            document.dispatchEvent(new Event('renderer-ready'));
        }).catch((error) => {
            if (error.response && error.response.status === 404) {
                let errorRoute = flagCarInStock ? '/kjarabilar/not-found' : '/nyir-bilar/not-found';
                router.push(errorRoute);
            }
        })
    },
    FETCH_CARS: (context) => {
        Axios.get('/new-cars/get').then(res => {
            context.commit('SET_DATA', {
                field: "page",
                data: res.data,
            });
            //context.commit('SET_CAR', res.data)
        }).catch((error) => {
            console.log('Error',error)
        })
    }
}